
import { API_CONFIG, apiUtils } from '../config.js';

const noticeApi = {
  // List Notices
  getNotices: async (filters = {}) => {
    const queryParams = apiUtils.buildQueryString(filters);
    const url = `${API_CONFIG.BASE_URL}/notice/findAll${queryParams ? '?' + queryParams : ''}`;
    return apiUtils.makeAuthenticatedRequest(url, { method: 'GET' });
  },

  // Get Notice Detail
  getNoticeById: async (id) => {
    const url = `${API_CONFIG.BASE_URL}/notice/findbyId/${id}`;
    return apiUtils.makeAuthenticatedRequest(url, { method: 'GET' });
  },

  // Create Notice
  createNotice: async (data) => {
    const url = `${API_CONFIG.BASE_URL}/notice/create`;
    return apiUtils.makeAuthenticatedRequest(url, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },

  // Update Notice
  updateNotice: async (id, data) => {
    const url = `${API_CONFIG.BASE_URL}/notice/updatebyId/${id}`;
    return apiUtils.makeAuthenticatedRequest(url, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  },

  // Delete Notice
  deleteNotice: async (id) => {
    const url = `${API_CONFIG.BASE_URL}/notice/deletebyId/${id}`;
    // Do not set body or Content-Type for DELETE
    return apiUtils.makeAuthenticatedRequest(url, { method: 'DELETE' });
  },
  // Send Notice (Trigger WhatsApp/SMS)
  sendNotice: async (id) => {
    const url = `${API_CONFIG.BASE_URL}/notice/send/${id}`;
    return apiUtils.makeAuthenticatedRequest(url, { 
      method: 'POST',
      body: JSON.stringify({}) // Empty body required to avoid "Body cannot be empty" error
    });
  },

  // Get WhatsApp Templates Definition
  getWhatsappTemplates: async () => {
    const url = `${API_CONFIG.BASE_URL}/whatsapp/waba/notice-templates`;
    return apiUtils.makeAuthenticatedRequest(url, { method: 'GET' });
  },
  
  // Send Bulk Notices via WhatsApp
  sendBulkNotices: async (academicYear) => {
    const params = academicYear ? `?academicYear=${academicYear}` : '';
    const url = `${API_CONFIG.BASE_URL}/notice/whatsapp/notices${params}`;
    return apiUtils.makeAuthenticatedRequest(url, { method: 'POST', body: JSON.stringify({}) });
  },

  // Send Bulk Events via WhatsApp
  sendBulkEvents: async (academicYear) => {
    const params = academicYear ? `?academicYear=${academicYear}` : '';
    const url = `${API_CONFIG.BASE_URL}/notice/whatsapp/events${params}`;
    return apiUtils.makeAuthenticatedRequest(url, { method: 'POST', body: JSON.stringify({}) });
  },
};

export const sendBulkNotices = noticeApi.sendBulkNotices;
export const sendBulkEvents = noticeApi.sendBulkEvents;

export const getNotices = noticeApi.getNotices;
export const getNoticeById = noticeApi.getNoticeById;
export const createNotice = noticeApi.createNotice;
export const updateNotice = noticeApi.updateNotice;
export const deleteNotice = noticeApi.deleteNotice;
export const sendNotice = noticeApi.sendNotice;
export const getWhatsappTemplates = noticeApi.getWhatsappTemplates;
export default noticeApi;
